module.exports = __webpack_public_path__ + "static/media/img-email-success.acef9fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img-email-success.png
// module id = 1822
// module chunks = 3